import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { pick, pipe } from 'ramda';

import * as helpers from '@core/js/components/main/NavigationBar/helpers';
import * as hooks from '@core/js/components/main/NavigationBar/hooks';
import { useAppSelector } from '@core/js/store/hooks';

export const useGetAvailableMenuItems = (currentPageURL: string) => {
    const location = useLocation();
    const { rootPage, menuItems, chatWidget, inboxWidget } = useAppSelector(pick(['rootPage', 'menuItems', 'chatWidget', 'inboxWidget']));

    const filterByRoleAvailability = hooks.useFilterByRoleAvailability();

    return useMemo(() => menuItems?.length
        ? pipe(
            helpers.getMenuSiblingsByUrl(currentPageURL || rootPage),
            filterByRoleAvailability,
            helpers.markMenuItemAsOpener(chatWidget, inboxWidget),
            helpers.filterByUrlAvailability(location.search)
        )(menuItems)
        : [],
    [
        location,
        rootPage,
        menuItems,
        chatWidget,
        inboxWidget,
        currentPageURL,
        filterByRoleAvailability
    ]);
};
